import React from 'react';

/**
 * 가로 플라이아웃 메뉴 테스트 페이지
 */
const TestFlyout = () => {
  return (
    <div className="max-w-[800px] mx-auto mt-[100px] px-5 py-10">
      <h1 className="text-[32px] mb-4">Flyout Menu Test</h1>
      <p className="text-base text-[#666] mb-10">상단 네비게이션의 메뉴에 마우스를 올려보세요.</p>

      <div className="bg-[#f5f5f7] p-6 rounded-xl">
        <h2 className="text-lg mb-4">변경 사항</h2>
        <ul className="list-disc pl-5">
          <li className="mb-2 text-[#333]">플라이아웃 메뉴: 세로 → 가로 배열</li>
          <li className="mb-2 text-[#333]">설명 텍스트 숨김 (컴팩트)</li>
          <li className="mb-2 text-[#333]">아이콘 크기 축소</li>
        </ul>
      </div>
    </div>
  );
};

export default TestFlyout;
